// Opt-in: formatted number, currency and percentage inputs. Large (about 200 KB minified), so only for apps that use it.
import AutonumericController from './autonumeric_controller'

export function register(application) {
  application.register('autonumeric', AutonumericController)
}
